export const tenantRadiusCheck = {
  path: '/api/v1/radius',
  method: 'GET',
};

export function searchTenantRadius(search, contentType) {
  return {
    accept: contentType,
    path: `radius${search}`,
  };
}

export function resetTenantVlansByUnit(unitId) {
  return {
    path: 'radius/reset_vlans/unit',
    body: JSON.stringify({ id: unitId }),
    method: 'POST',
  };
}

export function resetTenantVlansByBuilding(buildingId) {
  return {
    path: 'radius/reset_vlans/building',
    body: JSON.stringify({ id: buildingId }),
    method: 'POST',
  };
}

export function resetTenantVlansByNas(nasId) {
  return {
    path: 'radius/reset_vlans/nas',
    body: JSON.stringify({ id: nasId }),
    method: 'POST',
  };
}

export function deleteRadiusReply(id) {
  return {
    path: `radius/reply/${id}`,
    method: 'DELETE',
  };
}

export function deleteRadiusCheck(id) {
  return {
    path: `radius/check/${id}`,
    method: 'DELETE',
  };
}
